import { render } from "./WarnBtn.vue?vue&type=template&id=4b538a55&scoped=true"
import script from "./WarnBtn.vue?vue&type=script&lang=js"
export * from "./WarnBtn.vue?vue&type=script&lang=js"

import "./WarnBtn.vue?vue&type=style&index=0&id=4b538a55&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b538a55"]])

export default __exports__